// react
import PropTypes from "prop-types";
import React from "react";

// components
import Icon from "../../components/Icon";

/**
 * @deprecated Use the Checkbox component from the py-components package instead
 */
export default class InputCheckbox extends React.Component {
	static propTypes = {
		disabled: PropTypes.bool,
		value: PropTypes.bool,
		isRadioStyle: PropTypes.bool,
		onChange: PropTypes.func,
		size: PropTypes.number,
		iconSize: PropTypes.number,
		className: PropTypes.string,
		name: PropTypes.string,
		id: PropTypes.string,
		labelId: PropTypes.string,
	};

	static defaultProps = {
		className: "",
		name: "",
		size: 20,
		iconSize: 11,
		isRadioStyle: false,
		value: false,
		disabled: false,
		onChange: () => {},
	};

	handleClick = () => {
		if (this.props.disabled) {
			return;
		}

		this.props.onChange(!this.props.value);
	};

	handleKeyDown = (event) => {
		if (event.key === " ") {
			event.preventDefault();
			this.handleClick();
		}
	};

	render() {
		const { id, labelId, name, value, size, iconSize, disabled, className, isRadioStyle } = this.props;

		const borderlessSize = size - 2;
		const iconPosition = (borderlessSize - iconSize) / 2;

		const boxStyle = {
			height: borderlessSize,
			width: borderlessSize,
			lineHeight: `${borderlessSize}px`,
		};

		return (
			<div
				id={id}
				role="checkbox"
				aria-checked={value}
				aria-labelledby={labelId}
				tabIndex={disabled ? undefined : 0}
				data-testid={disabled ? "disabled-checkbox" : "checkbox"}
				name={name}
				onClick={this.handleClick}
				onKeyDown={this.handleKeyDown}
				className={`component-input-checkbox ${className} ${disabled ? "is-disabled" : ""}`}
			>
				<div
					style={boxStyle}
					className={`checkbox ${value ? "is-checked" : ""} ${isRadioStyle ? "is-radio" : ""}`}
					data-testid={`checkbox-${name}`}
				>
					{value ? (
						<div
							style={{
								position: "absolute",
								top: iconPosition,
								left: iconPosition,
							}}
						>
							<Icon
								name={isRadioStyle ? "circle" : "check"}
								data-testid={isRadioStyle ? "circle" : "check"}
								size={iconSize}
							/>
						</div>
					) : (
						""
					)}
				</div>
			</div>
		);
	}
}
